module.exports = __webpack_public_path__ + "static/media/Union.98858ea0.svg";